module.exports = "/_next/static/images/cz-047e732decd62b9d3ce350a2cd8f4de6.svg";